// lottieAnimations JS, animates illustration card graphics on hover . 
// datarobot6/views/gutenberg/content/dr-illustration-cards.twig

// Function to load and initialize Lottie animations with hover events
function loadLottieAnimation(container) {
    const animationPath = container.dataset.animationPath;

    if (animationPath) {
        const animation = window.lottie.loadAnimation({
            container: container,
            renderer: 'svg', // SVG renderer
            loop: false, // Manual loop control
            autoplay: false, // Do not autoplay
            path: animationPath // Path to the animation JSON
        });

        const button = container.closest('.illustrationCards__card')?.querySelector('.illustrationCards__button');
        let isHovered = false;

        // Wait for animation data to load
        animation.addEventListener('config_ready', () => {
            const totalFrames = animation.animationData.op;
            const hoverEndFrame = Math.min(30, totalFrames); // Ensure hover animation doesn't exceed total frames

            if (button) {
                // Play the first 30 frames on hover
                button.addEventListener('mouseenter', () => {
                    if (isHovered) return; // Prevent re-triggering
                    isHovered = true;

                    animation.stop(); // Stop any lingering animation state
                    animation.playSegments([0, hoverEndFrame], true); // Play frames 0 to 30

                    // Pause at the last frame of the segment once complete
                    //animation.addEventListener(
                       // 'complete',
                        //() => {
                            //if (isHovered) {
                                //animation.goToAndStop(hoverEndFrame, true); // Pause at frame 30
                                //console.log(`Hover Hold: Paused at frame ${hoverEndFrame}`);
                            //}
                       // },
                        //{ once: true }
                    //);
                    console.log(`Hover Start: Playing frames 0 to ${hoverEndFrame}`);
                });

                // Reverse back to frame 0 on mouseleave
                button.addEventListener('mouseleave', () => {
                    if (!isHovered) return; // Ignore redundant events
                    isHovered = false;

                    const currentFrame = animation.currentFrame;

                    if (currentFrame > 0) {
                        animation.stop(); // Stop any lingering animation state
                        animation.playSegments([currentFrame, 0], true); // Reverse to frame 0
                        console.log(`Hover End: Reversing from frame ${currentFrame} to 0`);
                    } else {
                        console.log(`Hover End: Already at frame 0`);
                    }
                });
            }
        });
    }
}

// Lazy load animations using Intersection Observer
document.addEventListener('DOMContentLoaded', function () {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                loadLottieAnimation(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });

    document.querySelectorAll('.lottieContainer').forEach(container => {
        observer.observe(container);
    });
});
